import {
  Farm,
  GrazingOffMovementItem,
  GrazingOnMovementItem,
  LivestockBalanceItem,
  LivestockMovementItem,
} from 'api/models'
import { GhgNavStep } from './ghg-calculator.nav'

//
// Increase this version if we introduce a schema change that would
// break the form if user already have data store in localStorage in old format
//
// This will effectively change localStorage key the form used to store and load data from.
//
const STORAGE_KEY_VERSION = 3
export function ghgFormLocalStorageKey(userId: number) {
  return `ghg-calculator-form-${STORAGE_KEY_VERSION}-${userId}`
}

export type FarmDetailState = Omit<Farm, 'id'> & {
  season_year: null | number
}

export type GrazingOnMovementItemFrontend = GrazingOnMovementItem & {
  classification: null | number
  on_hand_at_open: boolean
  on_hand_at_close: boolean
}

export type GrazingOffMovementItemFrontend = GrazingOffMovementItem & {
  classification: null | number
  on_hand_at_open: boolean
  on_hand_at_close: boolean
}

/**
 * The complete front-end state, including data from all the tabs and current
 * navigation.
 */
export interface FullState {
  currentStep: GhgNavStep
  farmDetail: FarmDetailState
  livestockBalances: LivestockBalanceItem[] | undefined
  livestockMovements: LivestockMovementItem[] | undefined
  grazingOnMovements: GrazingOnMovementItemFrontend[]
  grazingOffMovements: GrazingOffMovementItemFrontend[]
}

/**
 * The state we persist into local storage, for a new calculation.
 * The main difference is that it includes the date of modification, so we
 * can display that in the landing page menu.
 */
export interface LocalStorageState extends FullState {
  draftModifiedAt: string
}
